'use strict';

module.exports = require('./slider');


//////////////////
// WEBPACK FOOTER
// /Users/ddcat/project/ant-design-pro-site/ant-design-pro-site/scaffold/node_modules/_react-slick@0.16.0@react-slick/lib/index.js
// module id = 288
// module chunks = 0